import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./Home/home";
import Me from "./AboutMe/Me";
import Github from "./Github/Github";
import Projects from "./Projects/Projects";
import Writings from "./Writing/Writings";
import NoPage from "./NoPage";
import Header from "./Home/Header";

import { useState, useEffect } from "react";
import styled, { ThemeProvider } from "styled-components";

import { GlobalStyles } from "./theme/GlobalStyles";
import { useTheme } from "./theme/useTheme";
import WebFont from "webfontloader";
import { BGImage } from "./Home/Card";
// 2: Create a cotainer
const Container = styled.div`
  margin: 5px auto 5px auto;
`;

function App() {
  // 3: Get the selected theme, font list, etc.
  const { theme, themeLoaded, getFonts } = useTheme();
  const [selectedTheme, setSelectedTheme] = useState(theme);

  useEffect(() => {
    setSelectedTheme(theme);
  }, [themeLoaded]);

  // 4: Load all the fonts
  useEffect(() => {
    if (typeof window !== "undefined") {
      WebFont.load({
        google: {
          families: ["Droid Sans", "Droid Serif"],
        },
      });
    }
  });

  return (
    <>
      {/* {themeLoaded && (
        <ThemeProvider theme={selectedTheme}>
          <GlobalStyles />
          <Container style={{ fontFamily: selectedTheme.font }}>
           
          </Container>
        </ThemeProvider>
      )} */}

      <BrowserRouter basename={process.env.PUBLIC_URL}>
        <Routes>
          <Route path="/" element={<Header />}>
            <Route index element={<Home />} />
            <Route path="me" element={<Me />} />
            <Route path="writings" element={<Writings />} />
            <Route path="projects" element={<Projects />} />
            <Route path="github" element={<Github />} />
            <Route path="*" element={<NoPage />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
